import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Check, X } from 'react-feather';
import parse from 'html-react-parser';
import classnames from 'classnames';

import theme from 'constants/theme';

const FillTheGapResult = ({
  result,
  showCorrect,
  showYourAnswer,
  showCorrectIcon,
  iconsShow,
}) => {
  const renderParse = () => {
    const contentHTML = result?.contentHTML;

    const splitContent = contentHTML.split(/<select>(.*?)<\/select>/gm);

    const indexSelect = splitContent.reduce((total, item, index) => {
      if (item.includes('<option>-</option>')) {
        return [...total, index];
      }
      return total;
    }, []);

    const listFixAnswer = indexSelect.map((indexAnswer, index) => {
      const isCorrect = result?.resultAnswers?.[index]?.correct;
      const content = result?.resultAnswers?.[index]?.content;
      const answer = result?.resultAnswers?.[index]?.answer;
      const yourAnswer = result?.result?.[index];

      return {
        index: indexAnswer,
        content: (
          <span key={index}>
            [
            {iconsShow && (
              <>
                {isCorrect ? (
                  <Check color={theme.success} />
                ) : (
                  <>
                    <X color={theme.danger} />{' '}
                    <span className="font-italic">{content} </span>
                  </>
                )}
              </>
            )}
            {showCorrectIcon && (
              <strong className={classnames(isCorrect && 'font-italic')}>
                {isCorrect ? answer : `(${answer})`}
              </strong>
            )}
            {showCorrect && (
              <strong className={classnames(isCorrect && 'font-italic')}>
                {answer}
              </strong>
            )}
            {showYourAnswer && (
              <span className="font-italic">{yourAnswer}</span>
            )}
            ]
          </span>
        ),
      };
    });

    const contentFormat = splitContent.reduce((total, item, index) => {
      const answerChange = listFixAnswer.find(
        (itemFixAnswer) => itemFixAnswer.index === index,
      );

      if (answerChange?.index) {
        return [...total, answerChange];
      }

      if (item.includes('<p')) {
        const itemRemoveTagP = item.replace('<p', '<span');
        return [...total, itemRemoveTagP];
      }

      return [...total, item];
    }, []);

    return contentFormat.map((item, index) => (
      <Fragment key={index}>
        {typeof item === 'string' ? parse(item) : item?.content}
      </Fragment>
    ));
  };

  return (
    <div id="fillTheGap" style={{ whiteSpace: 'pre-line' }}>
      {renderParse()}
    </div>
  );
};

FillTheGapResult.propTypes = {
  result: PropTypes.object.isRequired,
};

export default FillTheGapResult;
